import { jsx as t } from "react/jsx-runtime";
import { styled as r, css as o } from "styled-components";
import "react";
import { l as n } from "./index-cWJIh2Ap.js";
const a = ({ $variant: i }) => i === "h1" ? n["--ll-font-size-h1"] : i === "h2" ? n["--ll-font-size-h2"] : i === "h3" ? n["--ll-font-size-h3"] : i === "h4" ? n["--ll-font-size-h4"] : i === "h5" ? n["--ll-font-size-h5"] : i === "h6" ? n["--ll-font-size-h6"] : i === "p" ? n["--ll-font-size-p"] : i === "caption1" ? n["--ll-font-size-caption-1"] : i === "caption2" ? n["--ll-font-size-caption-2"] : n["--ll-font-size-h2"], e = ({ $color: i }) => i in n ? n[i] : i, s = r.span`
  overflow: hidden;
  display: inline-block;
  width: 100%;
  line-height: ${({ $lineHeight: i }) => i || 1.45};
  margin: 0 0 ${({ $noMargin: i }) => i ? "0" : "0.5em"} 0;
  font-size: inherit;
  font-weight: inherit;
`, y = r.div`
  ${(i) => o`
    text-align: ${i.$align};
    font-size: ${a(i)};
    font-family: ${i.$family === "sans-serif" ? n["--ll-font-family"] : n["--ll-font-family-mono"]};
    font-variant: ${i.$fontVariant};
    letter-spacing: ${i.$letterSpacing};
    color: ${e(i)};
    font-weight: ${n[i.$weight]};
    text-transform: ${i.$textTransform};
    overflow: hidden;
    display: flex;

    svg {
      height: ${a(i)};
      fill: ${e(i)};
    }

    ${s} {
      ${i.$lineClamp && o`
        ${i.$lineClamp === 1 ? `
              white-space: nowrap;
            ` : `
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: ${i.$lineClamp};
            `}
        overflow: hidden;
        text-overflow: ellipsis;
      `}
    }
  `}
`, H = ({
  children: i,
  variant: l = "p",
  align: f,
  color: $ = "--ll-color-on-background",
  lineClamp: h,
  noMargin: p,
  lineHeight: m,
  weight: c = "--ll-font-weight-medium",
  family: g = "sans-serif",
  className: d,
  fontVariant: w = "initial",
  textTransform: z = "none",
  letterSpacing: v
}) => {
  const x = ["caption1", "caption2", "p"].includes(l) ? "p" : l;
  return /* @__PURE__ */ t(
    y,
    {
      $variant: l,
      $align: f,
      $color: $,
      $lineClamp: h,
      $weight: c,
      $family: g,
      $fontVariant: w,
      $letterSpacing: v,
      $textTransform: z,
      children: /* @__PURE__ */ t(
        s,
        {
          as: x,
          className: d,
          $noMargin: p,
          $lineHeight: m,
          children: i
        }
      )
    }
  );
};
export {
  H as u
};
